import { Table } from 'flowbite-react';
import PropTypes from 'prop-types';
import { renderStar } from 'utils/utils';
import { statusFile } from 'utils/constants';

const DataTable = ({ data, columns, onRowClicked }) => {
  return (
    <Table striped={true} data-testid='list'>
      <Table.Head>
        {columns.map((item, key) => (
          <Table.HeadCell key={key}>{item.name}</Table.HeadCell>
        ))}
      </Table.Head>
      <Table.Body className="divide-y">
        {data?.map((item, key) => {
          return (
            <Table.Row
              key={key}
              className={`data-table-row bg-white dark:border-gray-700 dark:bg-gray-900 ${
                !item.isEmpty ? 'cursor-pointer' : ''
              }`}
              data-row-meta={JSON.stringify(item)}
              onClick={onRowClicked ? () => onRowClicked(item) : null}
            >
              {columns.map((col, index) => {
                return (
                  <Table.Cell key={index} data-testid="test-table-row">
                    {col.isStatus ? (
                      <>
                        <span
                          className={`${
                            item.status === statusFile.SAVED_REVIEW_SHEET
                              ? 'bg-green-100 text-green-800'
                              : item.status === statusFile.OPEN
                              ? 'bg-red-100 text-red-800'
                              : 'bg-gray-100 text-gray-800'
                          } text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900`}
                        >
                          {item[col.selector]}
                        </span>
                        <span>{item.file}</span>
                      </>
                    ) : col.isRating ? (
                      renderStar(item[col.selector])
                    ) : (
                      item[col.selector]
                    )}
                  </Table.Cell>
                );
              })}
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

DataTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      fileNumber: PropTypes.string,
      address: PropTypes.string,
      file: PropTypes.string,
      date: PropTypes.string,
      isCompleted: PropTypes.bool,
      partnerName: PropTypes.string,
      rating: PropTypes.number,
      baseScore: PropTypes.number,
      created_date: PropTypes.string,
      score: PropTypes.number,
      totalScore: PropTypes.number,
      percent: PropTypes.string,
    }),
  ),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      selector: PropTypes.oneOf([
        'address',
        'date',
        'statusTitle',
        'file',
        'fileNumber',
        'partnerCompanyName',
        'rating',
        'scoreAdjustment',
        'createdDate',
        'bmaScore',
        'totalScore',
        'percent',
      ]).isRequired,
      isStatus: PropTypes.bool.isRequired,
      isRating: PropTypes.bool,
    }),
  ).isRequired,
  onRowClicked: PropTypes.func,
};

DataTable.defaultProps = {
  data: [
    {
      fileNumber: '1234',
      address: 'Street Addr, City, ST 9999',
      file: '3 BMA Documents, 2 Verified',
      date: '06/07/2022 10:30am',
      isCompleted: false,
    },
    {
      fileNumber: '1234',
      address: 'Street Addr, City, ST 9999',
      file: '3 BMA Documents, 2 Verified',
      date: '06/07/2022 10:30am',
      isCompleted: false,
    },
    {
      fileNumber: '1234',
      address: 'Street Addr, City, ST 9999',
      file: '3 BMA Documents, 2 Verified',
      date: '06/07/2022 10:30am',
      isCompleted: true,
    },
    {
      fileNumber: '1234',
      address: 'Street Addr, City, ST 9999',
      file: '3 BMA Documents, 2 Verified',
      date: '06/07/2022 10:30am',
      isCompleted: true,
    },
    {
      fileNumber: '1234',
      address: 'Street Addr, City, ST 9999',
      file: '3 BMA Documents, 2 Verified',
      date: '06/07/2022 10:30am',
      isCompleted: true,
    },
    {
      fileNumber: '1234',
      address: 'Street Addr, City, ST 9999',
      file: '3 BMA Documents, 2 Verified',
      date: '06/07/2022 10:30am',
      isCompleted: true,
    },
  ],
};

export default DataTable;
